<script setup>
import { computed } from 'vue'
import MultiSelect from '@/components/form/MultiSelect.vue'
import { enumLabel } from '@/lib/labels.js'

/** Which kinds of activity an outcome is offered for (D-293): none chosen — every kind. */
defineProps({ modelValue: { type: Array, default: () => [] }, row: { type: Object, default: null }, context: { type: Object, default: null }, disabled: Boolean })
const emit = defineEmits(['update:modelValue'])
const options = computed(() => ['call', 'email', 'meeting', 'task'].map((v) => ({ value: v, label: enumLabel('activity', 'type', v) })))
</script>

<template>
  <MultiSelect :model-value="modelValue || []" :options="options" :disabled="disabled" @update:model-value="(v) => emit('update:modelValue', v)" />
</template>
